import React, { useCallback, useEffect, useState } from "react";
import CardTestimoni from "./components/Card";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd } from "react-icons/md";

const Testimoni = () => {
  const navigate = useNavigate();

  const [testimoni, setTestimoni] = useState([]);
  const [loading, setLoading] = useState(true);

  /**

* Ambil data testimoni
  */
  const fetchTestimoniData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get("/api_w/testimonials", {
        headers: {
          Authorization: localStorage.getItem("token"),
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });

      setTestimoni(response.data?.data || []);
    } catch (error) {
      toast.error(
        "Error fetching testimoni data: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setLoading(false);
    }
  }, []);

  /**

* Ambil data saat halaman pertama kali dibuka
  */
  useEffect(() => {
    fetchTestimoniData();
  }, [fetchTestimoniData]);

  /**

* Handle delete
  */
  const handleDelete = (deletedId) => {
    setTestimoni((prev) => prev.filter((item) => item.id !== deletedId));
  };

  /**

* Handle kembali ke halaman index
  */
  const handleEdit = (id) => {
    navigate(`/admin/edit-testimoni/${id}`);
  };

  return (
    <div className="mt-5 px-2">
      {/* Page Header */}{" "}
      <div className="mb-6 flex items-center justify-between">
        {" "}
        <div>
          {" "}
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
            Manajemen Testimoni{" "}
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Kelola testimoni dari pengguna
          </p>
        </div>
        {/* Button Tambah */}
        <button
          onClick={() => navigate("/admin/add-testimoni")}
          className="flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold text-white shadow-sm transition-colors hover:opacity-90"
          style={{
            background: "linear-gradient(to right, #16a34a, #15803d)",
          }}
        >
          <MdAdd className="h-5 w-5" />
          Tambah Testimoni
        </button>
      </div>
      {/* Loading */}
      {loading ? (
        <div className="py-16 text-center">
          <div className="border-r-transparent inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500" />

          <p className="mt-3 text-sm text-gray-500">Memuat data...</p>
        </div>
      ) : testimoni.length === 0 ? (
        /* Empty State */
        <div className="rounded-2xl bg-white p-16 text-center shadow-sm dark:bg-navy-700">
          <p className="text-gray-400">
            Belum ada testimoni. Tambahkan testimoni baru.
          </p>
        </div>
      ) : (
        /* Testimoni List */
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {testimoni.map((item) => (
            <CardTestimoni
              key={item.id}
              id={item.id}
              name={item.name}
              role={item.role}
              content={item.content}
              avatar_url={
                item.avatar_url ? item.avatar_url.split(",")[0] : null
              }
              onDelete={handleDelete}
              onEdit={handleEdit}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Testimoni;
